import React from 'react';
import { Link } from 'react-router-dom';
import { translatedText } from '../recoil-states/language-state';
import MainCountdown from './MainCountdown';

export const MainMinting_m = ({ openModal, textData, loacalelang }) => {
	return (
		<>
			<div className='count_down_m'>
				<MainCountdown />
			</div>
			<div className='about_minting_m'>
				<p className='pfpBox_header'>DUMAN PFP MINTING</p>
				<p className='pfpBox_info'>{textData?.main.pfpInfo}</p>
			</div>
			<div className='minting_time_m'>
				<p className='kct_minting_header'>1ST KONNECT NFT MINTING</p>
				<p className='pfpBox_minting_info'>
					Minting Time : TBA
					<br />
					{textData.main.pfpQuantity}
					<br />
					{textData.main.pfpPrice}
					<br />
					<span>{textData.main.pfpDiscount}</span>
					<br />
				</p>
			</div>
			<div className='pfp_rarity'>
				<h5>DUMAN PFP rarity</h5>
				<div className='rarity_table'>
					<ul className='rarity_menu'>
						<li>{loacalelang === 'en' ? 'Breed' : '품종'}</li>
						<li>{loacalelang === 'en' ? 'Poodle' : '푸들'}</li>
						<li>
							{loacalelang === 'en'
								? 'Border collie'
								: '보더콜리'}
						</li>
						<li>
							{loacalelang === 'en' ? 'Doberman' : '도베르만'}
						</li>
						<li>{loacalelang === 'en' ? 'Shiba Inu' : '시바'}</li>
						<li>
							{loacalelang === 'en'
								? 'French bulldog'
								: '프렌치 불독'}
						</li>
					</ul>
					<ul>
						<li>{loacalelang === 'en' ? 'Quantity' : '수량'}</li>
						<li>50</li>
						<li>100</li>
						<li>200</li>
						<li>400</li>
						<li>750</li>
					</ul>
					<ul>
						<li>{loacalelang === 'en' ? 'Rarity' : '희소성'}</li>
						<li>3%</li>
						<li>7%</li>
						<li>13%</li>
						<li>27%</li>
						<li>50%</li>
					</ul>
				</div>
			</div>
			<div className='kct_pfp_rarity_btn'>
				<button
					disabled={true}
					style={{ opacity: 0.5 }}
					onClick={
						openModal
						// ()=>{
						//     alert(textData.header.closed);
						// }
					}
				>
					{textData.main.vitualMinting} &#62;
				</button>
				<button>
					<Link
						to='/Gallery'
						style={{ textDecoration: 'none', color: '#fff' }}
					>
						{textData.main.virtualGallery} &#62;
					</Link>
				</button>
			</div>
		</>
	);
};
